<script>
import useSharedData from "@/use/SharedData";
import {ref, watch} from "vue";
import ImageCropper from "@/components/ImageCropper.vue";
import {useSecurityStore} from "@/stores/Security";
import axios from "axios";

export default {
    components: {ImageCropper},
    props: {
        workerId: Number,
        readonly: Boolean,
        size: String,
        disableCard: Boolean,
    },
    name: "WorkerImage",
    setup(props, {emit}) {
        const securityStore = useSecurityStore();

        const {loading, dialog, overlay} = useSharedData();
        dialog.value = false;
        const blob = ref(null);
        const menu = ref(false);
        const imageUrl = ref(null);


        function displayBlob() {
            // Convert Blob to data URL
            const reader = new FileReader();
            reader.onload = () => {
                imageUrl.value = reader.result;
            };
            reader.readAsDataURL(blob.value);
        }

        function save() {
            if (blob.value) {
                displayBlob();
                emit('input', blob.value);
            }
            dialog.value = false;
        }

        function findByWorkerId() {
            loading.value = true;
            axios.get(`/workerImages/${props.workerId}`, {responseType: 'blob'}).then(response => {
                if (response.data.size > 0)
                    imageUrl.value = URL.createObjectURL(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        watch(() => props.workerId, () => {
            if (props.workerId)
                findByWorkerId();
        }, {immediate: true});

        return {
            securityStore,
            loading,
            menu,
            dialog,
            overlay,
            blob,
            imageUrl,
            save
        }
    },

}
</script>

<template>
    <div>
        <v-dialog
                v-model="dialog"
                persistent
                scrollable
                max-width="1000"
        >
            <v-card>
                <v-toolbar flat dense dark color="teal">
                    <v-toolbar-title></v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <ImageCropper v-model="blob"/>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                            depressed
                            outlined
                            color="teal"
                            @click="dialog = false"
                    >
                        {{ $t('common.close') }}
                        <v-icon right>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                            depressed
                            color="teal"
                            class="white--text"
                            @click="save"
                    >
                        Appliquer
                        <v-icon right>mdi-gesture-tap-hold</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-menu
            v-if="disableCard"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="200"
            open-on-hover
            offset-x
        >
            <template v-slot:activator="{ on, attrs }">
                <v-avatar
                    v-bind="attrs"
                    v-on="on"
                    size="50"
                    class="ma-1"
                >
                    <img :src="imageUrl ? imageUrl : `${securityStore.getImageLink()}/empty-profile.jpg`" alt=""/>
                </v-avatar>
            </template>

            <v-card>
                <v-container fluid>
                    <v-row justify="center" align="center">
                    <v-avatar size="300" class="ma-4">
                        <img :src="imageUrl ? imageUrl : `${securityStore.getImageLink()}/empty-profile.jpg`" alt=""/>
                    </v-avatar>
                    </v-row>
                </v-container>
            </v-card>
        </v-menu>


        <v-card v-else>
            <v-container fluid>
                <v-row justify="center" align="center">
                    <v-avatar :size="size ? size : '120'" class="ma-1" @mouseenter="overlay = true" @mouseleave="overlay = false">
                        <v-overlay :value="overlay" absolute>
                            <v-btn icon @click="dialog = true" v-if="!readonly">
                                <v-icon>mdi-pencil-box-multiple</v-icon>
                            </v-btn>
                        </v-overlay>

                        <img
                                :src="imageUrl ? imageUrl : `${securityStore.getImageLink()}/empty-profile.jpg`"
                         alt=""/>
                    </v-avatar>
                </v-row>
            </v-container>
        </v-card>

        <input type="hidden"/>
    </div>
</template>